module.exports = __webpack_public_path__ + "static/media/landing-bg.5a2dde37.jpg";